import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SocialMediaItem } from '@core/models/social-media/social-media.model';
import { GeneralInformationService } from '@services/assets-S3/general-information.service';

@Component({
  selector: 'app-social-media-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './social-media-list.component.html',
})
export class SocialMediaListComponent {
  generalInformationService: GeneralInformationService = inject(
    GeneralInformationService
  );

  socialMediaList$: Observable<SocialMediaItem[]> =
    this.generalInformationService.getSocialMediaList();
}
